
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.223","height":"22.2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 14"}},[_c('g',{attrs:{"data-name":"Group 13"}},[_c('path',{attrs:{"data-name":"Path 13","d":"M15.963 17.938l-1.076-2.014v-4.975a6.771 6.771 0 00-4.9-6.491V1.975a1.88 1.88 0 00-3.761 0v2.483a6.771 6.771 0 00-4.9 6.491v4.974L.25 17.937a1.24 1.24 0 001.1 1.823h4.273a2.486 2.486 0 004.963 0h4.273a1.24 1.24 0 001.1-1.823zM7.226 1.975a.885.885 0 011.771 0v2.276a6.825 6.825 0 00-1.771 0zm-4.9 8.974a5.781 5.781 0 0111.562 0v4.564H2.33zm5.781 10.159a1.491 1.491 0 01-1.484-1.347h2.972a1.491 1.491 0 01-1.484 1.347zm6.968-2.459a.245.245 0 01-.213.12H1.356a.248.248 0 01-.219-.365l1.015-1.9h11.919l1.015 1.9a.244.244 0 01-.007.245z","fill":"#1d2e90","stroke":"#1d2e90","stroke-width":".2"}})])]),_c('g',{attrs:{"data-name":"Group 16"}},[_c('g',{attrs:{"data-name":"Group 15"}},[_c('path',{attrs:{"data-name":"Path 14","d":"M8.077 6.523a4.408 4.408 0 00-4.4 4.4.492.492 0 10.983 0 3.424 3.424 0 013.42-3.42.492.492 0 000-.983z","fill":"#1d2e90","stroke":"#1d2e90","stroke-width":".2"}})])])])
          )
        }
      }
    